import RadioGroup from "../form/grouped/radio/radio-group";
import { PaymentMethodEnum } from "../../models/enum/payment-method.enum";

interface PaymentProps {
  PaymentHandler?: (value: string) => void;
  selectedPaymentMethod?: string;
}

const PaymentMethod = ({ PaymentHandler, selectedPaymentMethod }: PaymentProps) => {

  return (
    <div className="polymer-payment-method-container">
      <div className="polymer-payment-method-container-content">
        <p className="polymer-payment-method-container-content__title">Mode of payment:</p>      
        <RadioGroup
          required
          layout="default"
          items={[
            { id: 1, description: "Credit/ Debit card", value: PaymentMethodEnum.card, variant: "default" },
            // { id: 2, description: "PayNow", value: PaymentMethodEnum.paynow, variant: "default" },
          ]}
          value={selectedPaymentMethod}
          onItemSelect={(value) => {
            if(PaymentHandler) {
              PaymentHandler(value);
            }
          }}
        />   
      </div>
    </div>
  );
};

export default PaymentMethod;
